import { LinksRepository } from '@/repositories/fo-manual-API/IEntityRepository';
import { axiosInstance } from '@/repositories/fo-manual-API/Repository';
import { patchConfig } from '@/repositories/fo-manual-API/AxiosHelper/axiosHelper';
import { AxiosRequestConfig } from 'axios';

const linksRepository: LinksRepository = {
  resource: '/links',

  patchConfig,

  getAll(params) {
    const config: AxiosRequestConfig = {};

    if (params) {
      config.params = params;
    }

    return axiosInstance.get(`${this.resource}`, config);
  },
  get(id) {
    return axiosInstance.get(`${this.resource}/${id}`);
  },
  create(data) {
    const { layer1, layer2, layer3, htmlDocName } = data;
    const payload = {
      layer1,
      layer2,
      layer3,
      htmlDocName,
    };
    return axiosInstance.post(`${this.resource}`, payload);
  },
  update(id, data) {
    const { layer1, layer2, layer3, htmlDocName } = data;
    const payload = {
      layer1,
      layer2,
      layer3,
      htmlDocName,
    };
    return axiosInstance.patch(`${this.resource}/${id}`, payload, this.patchConfig);
  },
  delete(id) {
    return axiosInstance.delete(`${this.resource}/${id}`);
  },
};

export default linksRepository;
